import React from "react";
import DropDown from "get-life-storybook-ts/lib/components/Inputs/Input_DropDown/DropDown";
import Input from "get-life-storybook-ts/lib/atoms/Input/Input";
import SingleSelect from "get-life-storybook-ts/lib/components/Inputs/Input_Select/SingleSelect/SingleSelect";
import TextWithInfoIcon from "get-life-storybook-ts/lib/atoms/TextWithInfoIcon/TextWithInfoIcon";
import Typography from "get-life-storybook-ts/lib/atoms/Typography/Typography";
import GlobalIcon from "../Icons/GlobalIcon";
import CheckboxAtom from "get-life-storybook-ts/lib/atoms/Checkbox/Checkbox";
import BirthDateInput from "get-life-storybook-ts/lib/organisms/BirthDateInput/BirthDateInput";
import ButtonDS from "get-life-storybook-ts/lib/atoms/ButtonDS/ButtonDS";

import CalculatorModuleController, {
  StrapiDataCalculator,
} from "./CalculatorModule.controller";
import PhoneValidationModal from "../PhoneValidationModal/PhoneValidationModal";

interface OverlayI {
  isMobile?: boolean;
}

const OverlayCapital: React.FC<OverlayI> = ({ isMobile }) => {
  return (
    <div className="flex flex-col gap-4">
      <GlobalIcon iconName="CalculatorIcon" size={isMobile ? "M" : "L"} />
      <Typography
        variant="Body"
        text="El capital de cobertura es el dinero bajo el que te aseguras y el dinero que recibirá la persona o entidad que desees."
      />
      <Typography
        variant="Body"
        text="Puedes cambiarlo más adelante para que puedas comparar y elegir lo que más se ajuste a tus necesidades."
      />
    </div>
  );
};

const OverlayData: React.FC<OverlayI> = ({ isMobile }) => {
  return (
    <div className="flex flex-col gap-4">
      <Typography
        variant="Body"
        text="En Life5 tu información es confidencial, cuidamos tus datos y no los compartimos con otros."
      />
      <div className="flex flex-row gap-4">
        <GlobalIcon iconName="EmailIcon" size={isMobile ? "M" : "L"} />

        <div className="flex flex-col gap-1">
          <Typography
            variant="Body"
            className="text-[18px] md:text-[22px] leading-[120%] tracking-[-0.02em]"
            weight="700"
            text="Tu email"
            color="purple"
          />
          <Typography
            variant="Body"
            text="Para enviarte todos los pasos del proceso. Somos transparentes, queremos que tengas toda la documentación pertinente."
          />
        </div>
      </div>
      <div className="flex flex-row gap-4">
        <GlobalIcon iconName="CallIcon" size={isMobile ? "M" : "L"} />

        <div className="flex flex-col gap-1">
          <Typography
            variant="Body"
            className="text-[18px] md:text-[22px] leading-[120%] tracking-[-0.02em]"
            weight="700"
            text="Tu teléfono"
            color="purple"
          />
          <Typography
            variant="Body"
            text="Para poder ayudarte y asesorarte, nuestro objetivo es que encuentres el mejor producto para ti."
          />
        </div>
      </div>
    </div>
  );
};

const CalculatorModuleExample: React.FC<StrapiDataCalculator> = ({ data }) => {
  const {
    actualStep,
    capitalOptions,
    display,
    formDataFirst,
    formDataSecond,
    formError,
    HasSeriousIllnesses,
    handleBlur,
    handleButton,
    handleChange,
    handleFocus,
    isMobile,
    loading,
    optionsHaveInsurance,
    setActualStep,
    setDisplay,
    setFormDataFirst,
    setFormDataSecond,
    validations,
    refPhoneValidationModal,
    RegeneratePhoneValidationCode,
    ValidatePhoneValidationCode,
    trackStepBack,
  } = CalculatorModuleController({ data });

  const checkBoxQuery = (
    <>
      <div className="flex flex-col">
        <Typography
          variant="BodyMedium"
          text="Acepto el tratamiento de mis datos para recibir la información solicitada."
          color="ligth-gray"
        />
        <Typography
          variant="LinkMedium"
          text="Ver política de privacidad"
          color="ligth-gray"
          target="_blank"
          href="https://life5.es/politica-privacidad/"
        />
      </div>
    </>
  );

  const checkBoxQuery2 = (
    <>
      <div className="flex flex-col">
        <Typography
          variant="BodyMedium"
          text="Como persona asegurada voy a contestar veraz y detalladamente a cada pregunta de salud. No declarar todos mis antecedentes médicos podrá suponer la pérdida del derecho a la indemnización en caso de siniestro."
          color="ligth-gray"
        />
        <Typography
          variant="LinkMedium"
          text="Más información sobre dolo en seguros de vida"
          color="ligth-gray"
          target="_blank"
          href="https://life5.es/blog/seguros/dolo/"
        />
      </div>
    </>
  );

  return (
    <>
      <div
        className={`w-full md:max-w-[450px] ${
          actualStep === 1 && display ? "min-h-[562px]" : "min-h-[528px]"
        } flex flex-col pt-6 px-4 pb-8 gap-8 rounded-lg shadow-lg`}
        style={{
          backgroundColor:
            (data && data[0] && data[0].backgroundColor) ?? "#F5F7FA",
        }}
      >
        <div className="flex flex-col justify-center items-center gap-6">
          <div className="flex flex-row gap-4 w-full">
            <Typography
              variant="BodySmall"
              text="Paso 1"
              color={actualStep === 1 ? "purple" : "ligth-gray"}
              onClick={() => {
                if (actualStep > 1) {
                  trackStepBack(actualStep, 1);
                  setActualStep(1);
                }
              }}
              className="cursor-pointer"
            />
            <Typography variant="BodySmall" text=">" color="ligth-gray" />
            <Typography
              variant="BodySmall"
              text="Paso 2"
              color={actualStep === 2 ? "purple" : "ligth-gray"}
              className={`${
                actualStep === 1 ? "cursor-pointer" : "cursor-not-allowed"
              }`}
              onClick={() => {
                if (actualStep === 1) {
                  setActualStep(2);
                }
              }}
            />
            <Typography variant="BodySmall" text=">" color="ligth-gray" />
            <Typography
              variant="BodySmall"
              text="Tu precio"
              color="ligth-gray"
            />
          </div>
          {actualStep === 1 && (
            <>
              {!display && (
                <>
                  <BirthDateInput
                    label="Fecha de Nacimiento"
                    initialValue={formDataFirst.birthDate}
                    handleFocus={handleFocus}
                    setter={(birthDate: string) =>
                      setFormDataFirst({
                        ...formDataFirst,
                        birthDate,
                      })
                    }
                    birthDateError={formError?.birthDate}
                  />
                  <div className="flex flex-col w-full">
                    <Typography
                      variant="Body"
                      text="¿Tienes un seguro de vida actualmente?"
                      color="gray-text"
                    />
                    <div className="flex flex-col gap-4">
                      <SingleSelect
                        name="intention_select"
                        initialValue={formDataFirst.haveInsurance}
                        onValueChange={(e: any) =>
                          handleChange({
                            setValue: setFormDataFirst,
                            value: e,
                            field: "haveInsurance",
                            formData: formDataFirst,
                          })
                        }
                        options={optionsHaveInsurance}
                        defaultVariant="Standard"
                        defaultSize="S"
                      />
                      {formError?.haveInsurance?.message && (
                        <Typography
                          text={formError?.haveInsurance?.message}
                          variant="BodySmall"
                          weight="400"
                          className="text-red"
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="flex flex-col w-full">
                <Typography
                  variant="Body"
                  text="Capital de cobertura"
                  color="gray-text"
                />
                <div className="flex flex-col gap-4">
                  <DropDown
                    isSimple
                    bgWhite
                    initialValue={(formDataFirst.capital || "") as string}
                    handleDisplay={(displayItem: boolean) =>
                      setDisplay(displayItem)
                    }
                    onValueChange={(e: any) =>
                      handleChange({
                        setValue: setFormDataFirst,
                        value: e,
                        field: "capital",
                        formData: formDataFirst,
                      })
                    }
                    options={capitalOptions}
                    disabled={capitalOptions.length === 0}
                    className="w-full"
                    placeholder="Seleccione una opción"
                    initialError={formError?.capital}
                  />
                </div>
                {capitalOptions.length > 0 && (
                  <TextWithInfoIcon
                    content={HasSeriousIllnesses ? "Aconsejamos 2 veces tu salario anual" : "Aconsejamos 8 veces tu salario anual"}
                    overlayPrice={<OverlayCapital isMobile={isMobile} />}
                    overlayTitle={
                      <Typography
                        variant="Body"
                        weight="700"
                        text="¿Qué es el capital de cobertura?"
                        className="text-[18px] md:text-[22px] leading-[120%] tracking-[-0.02em]"
                      />
                    }
                    overlayWidth={false}
                    infoIcon
                    position="left"
                    color="ligth-gray"
                    weight="400"
                    className="mt-2"
                  />
                )}
              </div>
            </>
          )}

          {actualStep === 2 && (
            <>
              <div className="flex flex-col w-full">
                <Typography variant="Body" text="Email" color="gray-text" />
                <div className="flex flex-row gap-4">
                  <Input
                    initialValue={formDataSecond.email}
                    inputMode="email"
                    autoComplete="email"
                    autoFocus
                    onBlur={() =>
                      handleBlur({ field: "email", formData: formDataSecond })
                    }
                    onValueChange={(e: any) =>
                      handleChange({
                        setValue: setFormDataSecond,
                        value: e,
                        field: "email",
                        formData: formDataSecond,
                      })
                    }
                    placeholder="Escribe tu correo electrónico"
                    initialError={formError?.email}
                    id="emailInput"
                  />
                </div>
              </div>
              <div className="flex flex-col w-full">
                <Typography variant="Body" text="Teléfono" color="gray-text" />
                <div className="flex flex-row gap-4">
                  <Input
                    initialValue={formDataSecond.phone}
                    inputMode="number"
                    autoComplete="phone"
                    pattern="\d*"
                    onBlur={() =>
                      handleBlur({ field: "phone", formData: formDataSecond })
                    }
                    onValueChange={(e: any) =>
                      handleChange({
                        setValue: setFormDataSecond,
                        value: e,
                        field: "phone",
                        formData: formDataSecond,
                      })
                    }
                    placeholder="Escribe tu número de teléfono"
                    initialError={formError?.phone}
                    id="phoneInput"
                  />
                </div>
              </div>
              <div className="flex flex-col w-full">
                <TextWithInfoIcon
                  content={"¿Por qué te pedimos estos datos?"}
                  overlayPrice={<OverlayData isMobile={isMobile} />}
                  overlayTitle={
                    <Typography
                      variant="Body"
                      weight="700"
                      text="¿Por qué te pedimos estos datos?"
                      className="text-[18px] md:text-[22px] leading-[120%] tracking-[-0.02em]"
                    />
                  }
                  overlayWidth={false}
                  infoIcon
                  position="left"
                  color="ligth-gray"
                  weight="400"
                  className="mt-2"
                />
              </div>
              <div className="flex flex-col w-full">
                <CheckboxAtom
                  label={checkBoxQuery}
                  onValueChange={(checkedConditions: boolean) =>
                    handleChange({
                      setValue: setFormDataSecond,
                      value: checkedConditions,
                      field: "checkedConditions",
                      formData: formDataSecond,
                    })
                  }
                  isLegal
                  errorCheck={formError?.checkedConditions}
                  className="!p-0"
                />
              </div>
              <div className="flex flex-col w-full">
                <CheckboxAtom
                  label={checkBoxQuery2}
                  onValueChange={(checkedConditions2: boolean) =>
                    handleChange({
                      setValue: setFormDataSecond,
                      value: checkedConditions2,
                      field: "checkedConditions2",
                      formData: formDataSecond,
                    })
                  }
                  isLegal
                  errorCheck={formError?.checkedConditions2}
                  className="!p-0"
                />
              </div>
            </>
          )}

          <div className="flex flex-col w-full">
            <ButtonDS
              label={actualStep === 1 ? "Continuar" : "Ver mi precio"}
              onClick={() => handleButton()}
              disabled={loading}
              rightIcon="ArrowRightIcon"
              className="w-full"
            />
          </div>
        </div>
      </div>
      <PhoneValidationModal
        modalRef={refPhoneValidationModal}
        phoneValue={formDataSecond.phone}
        phoneOnBlur={() =>
          handleBlur({ field: "phone", formData: formDataSecond })
        }
        PhoneOnValueChange={(e: any) =>
          handleChange({
            setValue: setFormDataSecond,
            value: e,
            field: "phone",
            formData: formDataSecond,
          })
        }
        phoneError={formError?.phone}
        GeneratePhoneValidationCode={RegeneratePhoneValidationCode}
        ValidatePhoneValidationCode={ValidatePhoneValidationCode}
      />
    </>
  );
};

export default CalculatorModuleExample;
